import { render, staticRenderFns } from "./comprovativosListagem.vue?vue&type=template&id=4857b6cc&scoped=true&"
import script from "./comprovativosListagem.vue?vue&type=script&lang=js&"
export * from "./comprovativosListagem.vue?vue&type=script&lang=js&"
import style0 from "./comprovativosListagem.vue?vue&type=style&index=0&id=4857b6cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857b6cc",
  null
  
)

export default component.exports